export const operationalProjects = [
  {
    slug: 'devxfactor',
    name: 'DevX Factor',
    category: 'SaaS and development workflows',
    status: 'Live / Active',
    url: 'https://devxfactor.com/',
    displayUrl: 'WWW.DEVXFACTOR.COM',
    description:
      'A SaaS platform for structured project requirements, proposal-ready PDFs, AI software blueprints, invoices, and development workflows.',
    keyPoints: ['Requirement workflows', 'Proposal-ready PDFs', 'AI software blueprints'],
  },
  {
    slug: 'satyamcode',
    name: 'SatyamCode',
    category: 'Full-stack development ecosystem',
    status: 'Live / Active',
    url: 'https://satyamcode.com/',
    displayUrl: 'WWW.SATYAMCODE.COM',
    description:
      'Freelance full-stack developer portfolio and resource ecosystem focused on web applications, MERN development, CMS systems, and business workflows.',
    keyPoints: ['MERN applications', 'CMS systems', 'Business workflow builds'],
  },
  {
    slug: 'physicsfactor',
    name: 'PhysicsFactor',
    category: 'Physics learning platform',
    status: 'Live / Active',
    url: 'https://physicsfactor.com/',
    displayUrl: 'WWW.PHYSICSFACTOR.COM',
    description:
      'A physics learning platform focused on structured concepts, concise revision, concept-building questions, and chapter-wise testing.',
    keyPoints: ['Structured concepts', 'Revision support', 'Chapter-wise testing'],
  },
  {
    slug: 'satyamsir',
    name: 'SatyamSir',
    category: 'Tutoring and mentoring',
    status: 'Live / Active',
    url: 'https://satyamsir.com/',
    displayUrl: 'WWW.SATYAMSIR.COM',
    description:
      'Personal tutoring and education platform for physics mentoring, resources, and student-focused learning support.',
    keyPoints: ['Physics mentoring', 'Student resources', 'Learning support'],
  },
];
